import { DEFAULT_SLOT_NAME } from '../model/BlockDecorator.js';
import { renderBlock } from './renderBlock.js';
const EMPTY_ANCESTORS = [];
export const renderBlocksList = (blocks, { key, ancestors = EMPTY_ANCESTORS, slotName = DEFAULT_SLOT_NAME, extraProps, renderProps = renderBlock, ...options }) => {
    const renderChildBlock = extraProps
        ? (childBlock, childOptions) => renderBlock(childBlock, childOptions, extraProps)
        : renderProps;
    return (blocks || []).map((_, i) => renderChildBlock(_, {
        ...options,
        key: `${key ? key : _.type}-${i}`,
        ancestors: options.parent
            ? [...(ancestors || EMPTY_ANCESTORS), [options.parent, slotName]]
            : ancestors,
    }, i));
};
//# sourceMappingURL=renderBlockList.js.map